var _G;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import Svg, { G, Rect, Path } from "react-native-svg";
function SvgHat(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 15 15"
  }, props), _G || (_G = /*#__PURE__*/React.createElement(G, {
    "data-name": "Tips - RTV Tipsters"
  }, /*#__PURE__*/React.createElement(Rect, {
    width: 15,
    height: 15,
    rx: 3,
    ry: 3,
    fill: "#1d1c39"
  }), /*#__PURE__*/React.createElement(Path, {
    d: "M13.18 9.04c0-.46-2.02-.97-2.02-.97-.57-3.02-1.51-4.29-1.94-4.29s-.7.62-1 .92c-.26.26-.65.35-.74.35-.1 0-.48-.08-.74-.35-.3-.3-.57-.92-1-.92S4.36 5.05 3.8 8.07c0 0-2.02.51-2.02.97s1.17 1.78 5.69 1.79c4.52 0 5.69-1.33 5.69-1.79z",
    fill: "#fff"
  }))));
}
export default SvgHat;